// ============================================================================
// ARABIC TRANSLATIONS - CHAPTER 2: الخروج
// ============================================================================
// المستويات 14-26 (13 مستوى، 39 سؤالاً)

export const chapter2Translations = {
  name: "الخروج",
  description: "تحرير شعب الله... معرفة الله تحول حياتنا",
  
  spiritualWisdom: {
    principle: "معرفة الله تحرر وتحول",
    scripture: "وتعرفون الحق، والحق يحرركم (يوحنا 8:32)",
    application: "كما تحرر إسرائيل من مصر، معرفة الله تحررنا من العبودية الروحية"
  },
  
  levels: {
    14: {
      name: "موسى المنقذ من المياه",
      challenge: "فحبلت المرأة وولدت ابناً. ولما رأته أنه حسن...",
      easy: {
        question: "في ماذا أخفت أم موسى ابنها؟",
        options: ["كهف", "سلة من البردي", "سلة", "منزل"],
        hint: "هذا الوعاء كان يطفو على النيل",
        funFact: "🏺 سلة البردي كانت مطلية بالقار لتكون محكمة الإغلاق!"
      },
      medium: {
        question: "من الذي وجد موسى بين القصب؟",
        options: [
          "ابنة فرعون",
          "خادمة مصرية",
          "أخته مريم",
          "كاهن مصري"
        ],
        hint: "عضو من العائلة الملكية المصرية",
        funFact: "👑 من المفارقات أن عائلة فرعون هي التي أنقذت من سيتحداه!"
      },
      hard: {
        question: "كيف تستخدم العناية الإلهية حتى أعداءنا؟",
        options: [
          "بتحويلهم",
          "بتنسيق الظروف لتحقيق مقاصدها",
          "بمعاقبتهم",
          "بتجاهلهم"
        ],
        hint: "يتعلق الأمر برؤية يد الله في الأحداث",
        funFact: "✨ نشأ موسى في قصر من كان يضطهد شعبه!"
      }
    },
    
    15: {
      name: "العليقة المشتعلة",
      challenge: "وظهر له ملاك الرب في لهيب نار من وسط عليقة...",
      easy: {
        question: "ماذا يجب أن يخلع موسى أمام العليقة المشتعلة؟",
        options: ["مجوهراته", "نعليه", "عباءته", "عمامته"],
        hint: "ما نرتديه على القدمين",
        funFact: "👡 خلع الحذاء يعبر عن الاحترام على أرض مقدسة!"
      },
      medium: {
        question: "أي اسم يكشفه الله لموسى؟",
        options: [
          "الرب",
          "أَهْيَهِ الَّذِي أَهْيَهْ (أنا هو الكائن)",
          "القدير",
          "الخالق"
        ],
        hint: "اسم يعبر عن الوجود المطلق",
        funFact: "🔥 يهوه (أنا هو) يكشف الجوهر الأبدي لله!"
      },
      hard: {
        question: "ماذا تعلمنا العليقة التي تحترق دون أن تحترق؟",
        options: [
          "السحر موجود",
          "الله يتجاوز قوانين الطبيعة",
          "النار مقدسة",
          "النباتات سحرية"
        ],
        hint: "يتعلق الأمر بالطبيعة الإلهية التي تتجاوز فهمنا",
        funFact: "🌿 العليقة ترمز إلى أن الحضور الإلهي يقدس دون أن يدمر!"
      }
    },

    16: {
      name: "الضربات العشر على مصر",
      challenge: "فأصر فرعون قلبه ولم يسمع لهم...",
      easy: {
        question: "ما هي الضربة الأولى على مصر؟",
        options: ["الضفادع", "الماء المتحول إلى دم", "الذباب", "القمل"],
        hint: "أصابت النيل، مصدر الحياة لمصر",
        funFact: "🩸 كان النيل يُعبد كإله، وأظهر الله تفوقه!"
      },
      medium: {
        question: "ما هي آخر وأفظع الضربات؟",
        options: [
          "البرد",
          "الظلام",
          "موت الأبكار",
          "الجراد"
        ],
        hint: "هذه الضربة أصابت العائلات مباشرة",
        funFact: "😢 هذه الضربة كسرت أخيراً كبرياء فرعون وحررت إسرائيل!"
      },
      hard: {
        question: "لماذا يقسي الله قلب فرعون؟",
        options: [
          "لمعاقبته",
          "لإظهار مجده وقوته",
          "بالخبث",
          "لإطالة المعاناة"
        ],
        hint: "يتعلق الأمر بالكشف عن من هو الإله الحقيقي",
        funFact: "⚡ الضربات تثبت أن يهوه أقوى من جميع آلهة مصر!"
      }
    },

    17: {
      name: "الفصح",
      challenge: "خذوا لكم شاة... وتجعلون من دمها على القائمتين...",
      easy: {
        question: "أين يجب على الإسرائيليين وضع دم الحمل؟",
        options: [
          "على ملابسهم",
          "على عتبات وقوائم الأبواب",
          "على جباههم",
          "في كؤوس"
        ],
        hint: "عند مدخل منازلهم",
        funFact: "🩸 الدم على الباب كان علامة الحماية الإلهية!"
      },
      medium: {
        question: "كيف يجب أن يأكلوا الحمل الفصحي؟",
        options: [
          "جالسين بارتياح",
          "في العائلة فقط",
          "أحقاؤهم مشدودة، نعالهم في أرجلهم، عصيهم في أيديهم",
          "في صمت"
        ],
        hint: "مستعدين للمغادرة",
        funFact: "🚶 كان عليهم أن يكونوا مستعدين للمغادرة بسرعة نحو الحرية!"
      },
      hard: {
        question: "كيف يرمز الحمل الفصحي للمسيح؟",
        options: [
          "بلونه الأبيض",
          "بذبيحته البديلة التي تنقذ من الموت",
          "بوداعته",
          "بعمره"
        ],
        hint: "يتعلق الأمر بالذبيحة التي تنجي من الدينونة",
        funFact: "🐑 يسوع يُدعى 'حمل الله الذي يرفع خطية العالم'!"
      }
    },

    18: {
      name: "عبور البحر الأحمر",
      challenge: "فمد موسى يده على البحر...",
      easy: {
        question: "كيف عبر الإسرائيليون البحر؟",
        options: [
          "بالقارب",
          "سباحة",
          "على اليابسة",
          "على طوف"
        ],
        hint: "كان قاع البحر صالحاً للسير",
        funFact: "🌊 حول الله عائقاً إلى طريق تحرير!"
      },
      medium: {
        question: "ماذا حدث للمصريين الذين كانوا يطاردونهم؟",
        options: [
          "عادوا أدراجهم",
          "غمرتهم المياه",
          "تاهوا",
          "انضموا إلى إسرائيل"
        ],
        hint: "عادت المياه عليهم",
        funFact: "⚔️ دُمر الجيش الأقوى في العالم في لحظة!"
      },
      hard: {
        question: "ماذا يرمز هذا العبور في حياتنا الروحية؟",
        options: [
          "الهروب من المشاكل",
          "الانتقال من عبودية الخطية إلى الحرية في الله",
          "تفوق إسرائيل",
          "تدمير الأعداء"
        ],
        hint: "يتعلق الأمر بتحول روحي",
        funFact: "🗽 البحر الأحمر يمثل المعمودية: موت للقديم، حياة جديدة!"
      }
    },

    19: {
      name: "المن في البرية",
      challenge: "ما هذا؟ لأنهم لم يعرفوا ما هو...",
      easy: {
        question: "كم من الوقت سقط المن؟",
        options: ["10 سنوات", "20 سنة", "40 سنة", "50 سنة"],
        hint: "نفس عدد السنوات في الصحراء",
        funFact: "🍞 لمدة 40 سنة، أطعم الله بطريقة معجزية 2 مليون شخص!"
      },
      medium: {
        question: "ماذا كان يحدث إذا احتفظوا بالمن أكثر من يوم؟",
        options: [
          "يصبح أكثر لذة",
          "يتكاثر",
          "يفسد ويصبح رائحته كريهة",
          "يتصلب"
        ],
        hint: "باستثناء يوم الجمعة للسبت",
        funFact: "🪱 علم الله بهذا الاعتماد اليومي عليه!"
      },
      hard: {
        question: "كيف يعلمنا المن الثقة؟",
        options: [
          "بالتخزين للمستقبل",
          "بالاعتماد على عناية الله اليومية",
          "بالعمل بجد أكبر",
          "بالمشاركة بالتساوي"
        ],
        hint: "يتعلق الأمر بالثقة يوماً بعد يوم",
        funFact: "🙏 'خبزنا كفافنا أعطنا اليوم' يأتي من هذه التجربة!"
      }
    },

    20: {
      name: "الماء من الصخرة",
      challenge: "اضرب الصخرة، وسيخرج منها ماء...",
      easy: {
        question: "بماذا يجب على موسى أن يضرب الصخرة؟",
        options: ["يده", "عصاه", "حجر", "مطرقة"],
        hint: "أداة معجزات موسى",
        funFact: "⚡ عصا موسى كانت أداة القوة الإلهية!"
      },
      medium: {
        question: "لماذا كان الشعب يتذمر ضد موسى؟",
        options: [
          "لم يكن هناك ماء للشرب",
          "كان الطعام ناقصاً",
          "الطريق كان طويلاً جداً",
          "كان الحر شديداً"
        ],
        hint: "حاجة حيوية في الصحراء",
        funFact: "💧 الماء أكثر أهمية من الطعام للبقاء على قيد الحياة!"
      },
      hard: {
        question: "ماذا يمثل الماء من الصخرة روحياً؟",
        options: [
          "الموارد الطبيعية",
          "الحياة الروحية التي تنبع من المسيح، الصخرة",
          "مكافأة الجهود",
          "السحر الإلهي"
        ],
        hint: "يقول بولس أن هذه الصخرة كانت المسيح",
        funFact: "🗿 المسيح هو الصخرة المضروبة التي تنبع منها الحياة الأبدية!"
      }
    },

    21: {
      name: "جبل سيناء",
      challenge: "وكان جبل سيناء كله يدخن، لأن الرب نزل عليه...",
      easy: {
        question: "كم عدد الوصايا التي أعطاها الله؟",
        options: ["5", "7", "10", "12"],
        hint: "رقم مستدير وكامل",
        funFact: "📜 الوصايا العشر هي الأساس الأخلاقي للإنسانية!"
      },
      medium: {
        question: "على ماذا كُتبت الوصايا؟",
        options: [
          "ورق البردي",
          "الرق",
          "لوحين من حجر",
          "البرونز"
        ],
        hint: "مادة دائمة كتبها إصبع الله",
        funFact: "✍️ مكتوبة من قبل الله نفسه لإظهار أهميتها الأبدية!"
      },
      hard: {
        question: "ما هو الهدف من الوصايا الإلهية؟",
        options: [
          "معاقبة الناس",
          "الكشف عن قداسة الله والتوجيه نحو السعادة",
          "خلق قواعد معقدة",
          "فصل الشعوب"
        ],
        hint: "يتعلق الأمر بكشف الطابع الإلهي وطريق الخير",
        funFact: "⚖️ الوصايا تكشف عن المحبة: محبة الله والقريب!"
      }
    },

    22: {
      name: "العجل الذهبي",
      challenge: "اصنع لنا آلهة تسير أمامنا...",
      easy: {
        question: "بماذا صنع هارون العجل الذهبي؟",
        options: [
          "قطع ذهبية",
          "أقراط الشعب الذهبية",
          "مجوهرات ثمينة",
          "ذهب من الصحراء"
        ],
        hint: "مجوهرات شخصية قدمها الشعب",
        funFact: "👂 قدم الشعب مجوهراته لخلق صنمه الخاص!"
      },
      medium: {
        question: "ما كان رد فعل موسى عندما رأى العجل؟",
        options: [
          "بكى",
          "صلى",
          "كسر لوحي الشريعة",
          "غضب فقط"
        ],
        hint: "إيماءة رمزية للعهد المكسور",
        funFact: "💥 كسر اللوحين كان رمزاً لأن العهد قد انتهك!"
      },
      hard: {
        question: "لماذا تعتبر عبادة الأصنام خطيرة جداً روحياً؟",
        options: [
          "إنها باهظة الثمن",
          "إنها تحول القلب من الإله الحقيقي إلى المخلوقات",
          "إنها تقسم العائلات",
          "إنها محرمة"
        ],
        hint: "يتعلق الأمر بإعطاء المخلوق ما يعود إلى الخالق",
        funFact: "💔 عبادة الأصنام تكسر العلاقة الحصرية مع الإله الحي!"
      }
    },

    23: {
      name: "المسكن",
      challenge: "فيصنعون لي مقدساً، فأسكن في وسطهم...",
      easy: {
        question: "ماذا كان يُسمى الخيمة المقدسة للإسرائيليين؟",
        options: ["الهيكل", "المسكن", "المقدس", "التابوت"],
        hint: "الاسم يعني 'خيمة الاجتماع'",
        funFact: "⛺ المسكن كان 'البيت المتنقل' لله مع شعبه!"
      },
      medium: {
        question: "ماذا كان يحتوي تابوت العهد؟",
        options: [
          "مجوهرات رئيس الكهنة",
          "لوحا الشريعة، المن، عصا هارون",
          "قطع ذهبية",
          "لفائف التوراة"
        ],
        hint: "ثلاثة أشياء ترمز إلى العهد مع الله",
        funFact: "📦 احتوى التابوت على 'ذكريات' الأمانة الإلهية!"
      },
      hard: {
        question: "ماذا يرمز المسكن في علاقتنا بالله؟",
        options: [
          "مبنى ديني",
          "حضور الله الذي يسكن بيننا وفينا",
          "مكان للذبائح فقط",
          "رمز وطني"
        ],
        hint: "يتعلق الأمر بالحضور الإلهي المتاح",
        funFact: "🏠 'جسدكم هو هيكل الروح القدس' بحسب بولس!"
      }
    },

    24: {
      name: "رئيس الكهنة هارون",
      challenge: "وتكرس هارون وبنيه ليكونوا لي كهنة...",
      easy: {
        question: "من كان أول رئيس كهنة لإسرائيل؟",
        options: ["موسى", "هارون", "يشوع", "ألعازار"],
        hint: "أخو موسى",
        funFact: "👨‍⚕️ هارون أسس النسل الكهنوتي الذي استمر أكثر من 1000 سنة!"
      },
      medium: {
        question: "ماذا كان يحمل رئيس الكهنة على صدره؟",
        options: [
          "صليب ذهبي",
          "الصدرة مع الأحجار الكريمة الاثني عشر",
          "ميدالية",
          "سلسلة ذهبية"
        ],
        hint: "اثنا عشر حجراً تمثل الأسباط الاثني عشر",
        funFact: "💎 رئيس الكهنة كان يحمل رمزياً كل إسرائيل على قلبه!"
      },
      hard: {
        question: "كيف يحقق يسوع دور رئيس الكهنة؟",
        options: [
          "بارتداء ملابس مقدسة",
          "بتقديم دمه مرة واحدة للأبد",
          "بالخدمة في الهيكل",
          "بكونه من نسل هارون"
        ],
        hint: "يتعلق الأمر بذبيحة كاملة ونهائية",
        funFact: "✝️ يسوع هو رئيس كهنة أبدي على رتبة ملكي صادق!"
      }
    },

    25: {
      name: "الذبائح",
      challenge: "إذا قدم أحد منكم قرباناً للرب...",
      easy: {
        question: "ما كانت الذبيحة اليومية في المسكن؟",
        options: [
          "ذبيحة السلامة",
          "المحرقة الصباحية والمسائية",
          "ذبيحة الخطيئة",
          "تقدمة الكعك"
        ],
        hint: "مرتين في اليوم، صباحاً ومساءً",
        funFact: "🔥 النار على المذبح كان يجب ألا تنطفئ أبداً!"
      },
      medium: {
        question: "ماذا كان يرمز وضع الأيدي على الحيوان؟",
        options: [
          "البركة",
          "نقل الخطايا إلى الضحية",
          "المودة للحيوان",
          "التكريس"
        ],
        hint: "إيماءة الاستبدال",
        funFact: "🤲 الحيوان كان يموت بدلاً من الخاطئ - مبدأ الاستبدال!"
      },
      hard: {
        question: "كيف تتنبأ هذه الذبائح بعمل المسيح؟",
        options: [
          "بعددها",
          "بالاستبدال: البريء يموت من أجل المذنب",
          "بتكلفتها",
          "بجمالها"
        ],
        hint: "يتعلق الأمر بمبدأ البريء الذي يأخذ مكان المذنب",
        funFact: "🐑 'جُرح من أجل معاصينا، سُحق من أجل آثامنا'!"
      }
    },

    26: {
      name: "على حدود الأرض الموعودة",
      challenge: "سأرسل أمامك ملاكاً، وأطرد الكنعانيين...",
      easy: {
        question: "كم عدد الجواسيس الذين أُرسلوا لاستكشاف الأرض الموعودة؟",
        options: ["10", "12", "20", "40"],
        hint: "واحد من كل سبط من أسباط إسرائيل",
        funFact: "🕵️ فقط 2 من أصل 12 جاسوساً قدموا تقريراً مشجعاً!"
      },
      medium: {
        question: "أي جواسيس شجعوا الشعب على دخول الأرض؟",
        options: [
          "هارون وموسى",
          "يشوع وكالب",
          "جاد وأشير",
          "رأوبين وشمعون"
        ],
        hint: "رجلان من الإيمان رأوا وعود الله",
        funFact: "🦁 يشوع وكالب كانا الوحيدين من جيلهما اللذين دخلا كنعان!"
      },
      hard: {
        question: "لماذا تاه إسرائيل 40 سنة في الصحراء؟",
        options: [
          "لمعاقبتهم",
          "بسبب عدم إيمانهم بالوعود الإلهية",
          "لتدريبهم على القتال",
          "للعثور على الطريق الصحيح"
        ],
        hint: "يتعلق الأمر بنقص الثقة بالله",
        funFact: "🏜️ كان على جيل كامل أن يموت بسبب عدم الإيمان!"
      }
    }
  }
};

export default chapter2Translations;
